/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { makeStyles } from '@material-ui/core';
import { bool, object } from 'prop-types';
import DesktopMobile from '../../../helpers/DesktopMobile/DesktopMobile';
import * as app from '../../../../state/ducks/App';
import GraphqlDesktopBanner from './Partials/GraphqlDesktopBanner/GraphqlDesktopBanner';
import GraphqlMobileBanner from './Partials/GraphqlMobileBanner/GraphqlMobileBanner';

const brandSelectors = app.ducks.brand.selectors;

const useStyles = makeStyles(() => ({
    textBanner: {
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        fontSize: '16px',
        fontWeight: 500,
        justifyContent: 'center',
        lineHeight: '21px',
        minHeight: '45px',
        padding: '12px 16px',
        textAlign: 'center',
        width: '100%',
    },
}));

const getCmsFieldValue = (value, fallback) => {
    if (typeof value === 'string' && value.trim()) return value.trim();
    if (value && typeof value === 'object') {
        return value.color || value.value || value.name || fallback;
    }
    return fallback;
};

const getCmsFontFamily = (value, fallback) => getCmsFieldValue(value, fallback)
    .replace(/^font-family\s*:\s*/i, '')
    .replace(/;\s*$/, '')
    .trim();

export const GraphqlBannerCodeBuilder = ({ pageData, isAutoPromoBannerEnabled }) => {
    const classes = useStyles();
    const bannerData = pageData.findBannerCode.content.entries[0];
    const {
        banner_message: bannerMessage = {},
        image_name = '',
        mobile_image_name = '',
        use_copy_instead_of_image_presentation: useCopyPresentation = false,
    } = bannerData;
    const hasBannerImage = Boolean(image_name || mobile_image_name);

    if (useCopyPresentation === true) {
        const message = bannerMessage?.message?.trim();
        if (!message || !isAutoPromoBannerEnabled) return null;

        const bannerStyle = {
            backgroundColor: getCmsFieldValue(bannerMessage.background_color, '#B8C9AD'),
            color: getCmsFieldValue(bannerMessage.text_color, '#000000'),
            fontFamily: getCmsFontFamily(bannerMessage.font, '"Museo Sans", "museo-sans", Arial, sans-serif'),
        };

        return (
            <div className={classes.textBanner} data-testid="banner-code-text-message" style={bannerStyle}>
                {message}
            </div>
        );
    }

    if (hasBannerImage) {
        return (
            <DesktopMobile
                desktop={() => <GraphqlDesktopBanner bannerImage={image_name || mobile_image_name} />}
                mobile={() => <GraphqlMobileBanner bannerImage={mobile_image_name || image_name} />}
            />
        );
    }

    return null;
};

GraphqlBannerCodeBuilder.propTypes = {
    pageData: object.isRequired,
    isAutoPromoBannerEnabled: bool,
};

GraphqlBannerCodeBuilder.defaultProps = {
    isAutoPromoBannerEnabled: false,
};

const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
});

export default withRouter(connect(mapStateToProps)(GraphqlBannerCodeBuilder));
